<template>
  <div  style="margin-top: 2%;" class="metricsDetail">
    <el-dialog :title="dialogTitle" :visible="isLookDetail" align="left" :close-on-click-modal ="false" width="50%" @close="close" height="50%">
      <el-row justify="center" type="flex">
        <el-col  >
          <el-table :data="detailData">
            <el-table-column prop="name" label="Name"  align="left"></el-table-column>
            <el-table-column prop="total_space" label="Total space (GB)"  align="left"></el-table-column>
            <el-table-column prop="available_space" label="Available space (GB)"  align="left"></el-table-column>
            \<el-table-column prop="available_space_percent" label="Available space (%)"  align="left"></el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
    export default {
        name: "metricsDetail",
        props:{
          detailData:{
            type:Array,
            default:[]
          }
        },
        data(){
          return {
            dialogTitle:"Detail",
            isLookDetail:true
          }
        },
      mounted(){
      },
      methods:{
        close:function(){
          this.$emit('close');
        }
      }
    }

</script>
<style scope>
.metricsDetail .el-dialog__body{
  height: 500px;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/page/activePublic/Metrics/storageDetail.vue